import { render, staticRenderFns } from "./Management-user.vue?vue&type=template&id=33cbe200&scoped=true&"
import script from "./Management-user.vue?vue&type=script&lang=js&"
export * from "./Management-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cbe200",
  null
  
)

export default component.exports